import { EpisodeHeader } from '@ksyos/design-system';
import { useParams } from '@ksyos/router';
import { supplyCategoriesByEpisodeCategory } from '@common/constants/supplyCategoriesByEpisodeCategory';
import { formatString } from '@common/utils/formatString';
import { PageTemplate } from '@frontend/components/templates/PageTemplate';
import { getSelectedLanguage } from '@frontend/translate';
import type { OrderSuppliesRouteParams } from './types/orderSuppliesRouteParams';
import { episodeCategoryIconName } from '../../elements/Icons/episodeCategoryIconName';
import { NotFoundError } from '../errors/NotFoundError';
import { OrderSuppliesCategorySelection } from './components/OrderSuppliesCategorySelection';
import { OrderSuppliesForm } from './components/OrderSuppliesForm';
import { OrderSuppliesOverview } from './components/OrderSuppliesOverview';
import {
    getEpisodeCategoryDisplayName,
    routeParamToEpisodeCategory,
    routeParamToSupplyCategory,
} from './utils/orderSuppliesRouteUtils';

export function OrderSupplies() {
    const { episodeCategory: episodeCategoryParam, supplyCategory: supplyCategoryParam } =
        useParams() as OrderSuppliesRouteParams;
    const translate = getSelectedLanguage();

    if (!episodeCategoryParam) {
        return (
            <PageTemplate width="medium">
                <EpisodeHeader
                    icon="general"
                    title="Materialen bestellen"
                />
                <OrderSuppliesOverview />
            </PageTemplate>
        );
    }

    const episodeCategory = routeParamToEpisodeCategory(episodeCategoryParam);
    const supplyCategory = supplyCategoryParam ? routeParamToSupplyCategory(supplyCategoryParam) : undefined;

    if (!episodeCategory) {
        return <NotFoundError />;
    }

    const hasValidSupplyCategory =
        supplyCategory && Object.keys(supplyCategoriesByEpisodeCategory[episodeCategory]).includes(supplyCategory);

    if (!(episodeCategory in supplyCategoriesByEpisodeCategory)) {
        return <NotFoundError />;
    }

    if (supplyCategoryParam && !hasValidSupplyCategory) {
        return <NotFoundError />;
    }

    return (
        <PageTemplate width="medium">
            <EpisodeHeader
                icon={episodeCategoryIconName(episodeCategory)}
                title={formatString(translate.orderSupplies.orderSuppliesForEpisodeCategory, [
                    getEpisodeCategoryDisplayName(episodeCategory),
                ])}
            />
            {!supplyCategory ? <OrderSuppliesCategorySelection /> : <OrderSuppliesForm />}
        </PageTemplate>
    );
}
